import { Capacitor, registerPlugin } from '@capacitor/core'

/**
 * Accès direct au module natif Android de connexion Google
 * (@capacitor-firebase/authentication), SANS importer son code JavaScript.
 *
 * Pourquoi : importer le paquet npm obligeait la compilation (npm run build)
 * à le trouver, et son installation entrait en conflit avec la version de
 * Firebase du projet. Ici on parle directement au code natif, enregistré
 * par « npx cap sync android » : la compilation ne dépend plus du paquet.
 */
export const FirebaseAuthentication = registerPlugin('FirebaseAuthentication')

// Le module natif est-il présent dans l'application Android ?
export const isNativeGoogleAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('FirebaseAuthentication')
